<div *ngIf="taskState != 'Done'" class="card mb-3">
    <div class="card-body">
        <div class="display-inline">
            <span class="material-icons pr-2 lh-30 display-inline align-middle">
                event
            </span>
            <h2 class="display-inline pr-2 mb-0 lh-30 f-15 align-middle">{{taskTitle}}</h2>
            <p class="mb-0">{{ 'projecttask.eventstart' | trans }}{{ taskStart | date: 'dd-MM-yyyy HH:mm' }} - {{
                taskEnd | date: 'HH:mm' }}</p>
            <p>{{ 'cplevent.duration' | trans }} - {{ getDuration(taskStart, taskEnd) }}</p>
        </div>
        <quill-view-html class="quill-no-pad" [content]="taskDescription"></quill-view-html>
    </div>
</div>

<div *ngIf="taskState == 'Done'" class="card mb-3">
    <div class="card-body">
        <div class="d-inline-flex">
            <span class="material-icons lh-25 align-middle" style="color:green;">
                task_alt
            </span>
            <h2 class="f-20 lh-25 align-middle pl-2 pr-2" style="font-weight: 500;">{{taskTitle}}</h2>
            <span class="badge badge-success" style="height:19px; margin-top:2px;">{{ 'cpllist.completed' | trans
                }}</span>
        </div>
        <p class="mb-0">{{ 'projecttask.eventstart' | trans }}{{ taskStart | date: 'dd-MM-yyyy HH:mm' }} - {{
            taskEnd | date: 'HH:mm' }}</p>
        <p>{{ 'cplevent.duration' | trans }} - {{ getDuration(taskStart, taskEnd) }}</p>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
    </div>
</div>